import React, { useEffect, useState } from 'react';
import DatePickerCalander from '../../../Utilities/DatePickerCalander';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

const CredentialingAddPlanPopup = ({
  close,
  credential_id = '',
  payerId = '',
  planId = '',
  reload,
}) => {
  const { user } = useSelector((store) => store.auth);
  // State variables for form fields
  const [planName, setPlanName] = useState('');
  const [planStatus, setPlanStatus] = useState('0');
  const [effectiveDate, setEffectiveDate] = useState('');
  const [note, setNote] = useState('');
  const [allData, setAllData] = useState('');

  useEffect(() => {
    try {
      const fetchData = async () => {
        const response = await post(
          'api/reports/managePayerMatrix/openAddPlanPopup',
          {
            payerId: credential_id, //payer id // instead of payer id credential_id is working
            planId: planId, //plan id while edit plan
          }
        );
        if (response.status === 200) {
          setAllData(response.data);
          if (planId) {
            setPlanName(response.data?.planDetail?.plan_name);
            setPlanStatus(response.data?.planDetail?.plan_status);
            setEffectiveDate(
              response.data?.planDetail?.plan_effective_date &&
                response.data?.planDetail?.plan_effective_date !== '0000-00-00'
                ? new Date(response.data?.planDetail?.plan_effective_date)
                : null
            );
            setNote(response.data?.planDetail?.plan_note);
          }
        }
      };
      fetchData();
    } catch (error) {
      setUiMessage('err', error?.message);
    }
  }, [credential_id, planId]);

  const handleSave = async () => {
    if (!planName) {
      setUiMessage('err', "Plan name can't be empty.");
      return;
    } else {
      try {
        const response = await post(
          'api/reports/managePayerMatrix/savePayerPlan',
          {
            payerId: payerId,
            credId: credential_id,
            planName: planName,
            planStatus: planStatus,
            planEffectiveDate: effectiveDate
              ? format(effectiveDate, 'yyyy-MM-dd')
              : '',
            credPlanNote: note,
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          setUiMessage('suc', 'Record added successfully.');
          reload();
          close();
        }
      } catch (error) {
        setUiMessage('err', error?.message);
      }
    }
  };

  const handleUpdate = async () => {
    if (!planName) {
      setUiMessage('err', "Plan name can't be empty.");
      return;
    } else {
      try {
        const response = await post(
          'api/reports/managePayerMatrix/updatePayerPlan',
          {
            planId: planId,
            payerId: payerId,
            credId: credential_id,
            planName: planName,
            planStatus: planStatus,
            planEffectiveDate: effectiveDate
              ? format(effectiveDate, 'yyyy-MM-dd')
              : '',
            credPlanNote: note,
            loginUserId: user?.id,
          }
        );
        if (response.status === 200) {
          setUiMessage('suc', 'Record updated successfully.');
          reload();
          close();
        }
      } catch (error) {
        setUiMessage('err', error?.message);
      }
    }
  };

  return (
    <div className="modalBackground">
      <div className="left view-sectn-blk">
        <span className="left clear-right5">Payer Plan:</span>
        <span className="right cursor bold red font-size16" onClick={close}>
          X
        </span>
      </div>

      <div className="left width100 pymnt-popup-inner-body">
        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Payer name:</span>
            <span
              className="post-pymnt-val left"
              style={{ width: 'calc(85% - 120px)' }}
            >
              {allData?.payerName}
            </span>
          </div>

          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Provider Name:</span>
            <span className="post-pymnt-val">
              {allData?.providerName?.fulname}
            </span>
          </div>
        </div>

        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Address:</span>
            <span className="post-pymnt-val" id="payerAddress">
              {allData?.payerAddress}
            </span>
          </div>

          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Payor ID:</span>
            <span className="post-pymnt-val" id="payerGatewayPayerId">
              {allData?.payerId}
            </span>
          </div>
        </div>

        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val width100">
            <span className="post-pymnt-lbl">Contact:</span>
            <span className="post-pymnt-val" id="payerContact">
              {allData?.payerContact}
            </span>
          </div>
        </div>

        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">
              Plan:<span className="required">*</span>
            </span>
            <span
              className="post-pymnt-val left"
              style={{ width: 'calc(85% - 120px)' }}
            >
              <input
                type="text"
                id="planName"
                name="planName"
                disabled={planId}
                value={planName}
                onChange={(e) => setPlanName(e.target.value)}
                style={{ width: '250px' }}
              />
            </span>
          </div>

          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Status:</span>
            <span className="post-pymnt-val">
              <select
                id="planStatus"
                value={planStatus}
                onChange={(e) => setPlanStatus(e.target.value)}
                className="chzn-select"
              >
                {allData?.status &&
                  allData?.status.length > 0 &&
                  allData?.status.map((ops, i) => {
                    return (
                      <option key={i} value={i}>
                        {ops?.[i]}
                      </option>
                    );
                  })}
                {/* <option value="0"></option>
                <option value="1">To Be Started</option>
                <option value="2">In-Process</option>
                <option value="3">Approved</option>
                <option value="4">Denied</option> */}
              </select>
            </span>
          </div>
        </div>

        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val">
            <span className="post-pymnt-lbl">Effective:</span>
            <span className="left clear-right">
              <DatePickerCalander
                selectedDate={effectiveDate}
                setSelectedDate={(e) => setEffectiveDate(e)}
                maxDate={new Date()}
              />
            </span>
          </div>
        </div>

        <div className="post-pymnt-rw">
          <div className="post-pymnt-rw-val width100">
            <span className="post-pymnt-lbl">Note:</span>
            <span className="post-pymnt-val">
              <textarea
                id="credPlanNote"
                name="credPlanNote"
                className="post-nt-txt white-bg"
                style={{ height: '70px' }}
                placeholder="Write here..."
                value={note}
                onChange={(e) => setNote(e.target.value)}
              ></textarea>
            </span>
          </div>
        </div>
      </div>

      <div className="bill-claim-edit-btn-rw">
        <button className="right clear-right" onClick={close}>
          <div className="button-cancel right">Cancel</div>
        </button>

        {planId ? (
          <button className="right clear-right" onClick={handleUpdate}>
            <div className="button-submit right" style={{ width: '125px' }}>
              Update
            </div>
          </button>
        ) : (
          <button className="right clear-right" onClick={handleSave}>
            <div className="button-submit right" style={{ width: '125px' }}>
              Save
            </div>
          </button>
        )}
      </div>
    </div>
  );
};

export default CredentialingAddPlanPopup;
